<template>
  <div class="registerFloat loginFloat">
    <dialogTem 
    :visible.sync="showloginfloat2" 
    :diaTitle="$t('dialog.login')" 
    :types="'login'"
    :diaWidth="'420px'"
    @handleCloseDialog="()=>setshowloginfloat2(false)" >
      <div class="login-body">
        <div class="box-left">
          <el-form
            class="form-horizontal newform"
            ref="ruleForm"
            label-width="100px"
            :model="user"
            :rules="rules"
            label-position="top"
          >
            <el-form-item prop="username">
              <div :class="{'signUpStyle':styleColor,signupComlabel:true}">
                {{$t('header.user')}}
              </div>
              <el-input type="text" v-model="user.username" autocomplete="off" :max="12" :disabled="isReady" 
              class="icon_username" clearable
                @keyup.enter.native="submitForm('ruleForm')"
                @focus="handleFocus(user.username,'username')"
                @blur="handleBlur(user.username,'username')">
                <i slot="prefix"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <div :class="{'signUpStyle':styleColor02,signupComlabel:true}">
                {{$t('header.password')}}
              </div>
              <el-input :type="flag ? 'password':'text'" v-model="user.password" 
              autocomplete="off" :max="12" class="icon_password"
              @keyup.enter="submitForm('ruleForm')"
              :disabled="isReady"
              @focus="handleFocus(user.password,'password')"
              @blur="handleBlur(user.password,'password')"
              >
              <i slot="suffix" :class="flag ? 'close_eye':'el-icon-view'" autocomplete="auto" @click="flag=!flag" />
              </el-input>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <div :class="{'signUpStyle':styleColor03,signupComlabel:true}">
                {{$t('header.verification')}}
              </div>
              <el-input
                type="text" class="icon_vercode"
                v-model="user.verificationCode"
                autocomplete="off"
                @keyup.enter.native="submitForm('ruleForm')"
                :disabled="isReady"
                @focus="handleFocus(user.verificationCode,'verificationCode')"
                @blur="handleBlur(user.verificationCode,'verificationCode')"
              >
                <i slot="prefix"></i>
                <template slot="suffix">
                  <img :src="user.securityCodeSrc" @click="!isReady && getVifyCode()" class="ng-hide" style="margin-top:6px;"/>
                   <i  @click="!isReady && getVifyCode()" class="fresh_ico"></i>
                </template>
              </el-input>
            </el-form-item>
            <div class="RememberMe">
              <el-checkbox v-model="checked">{{$t('header.RememberMe')}}</el-checkbox>
              <p class="forgetPosword forgetPosword2" @click="handleClickForgetPossword">{{$t('forget.title')}}</p>
            </div>
            <el-form-item class="btn-group">
              <el-button
                :loading="isReady"
                type="primary"
                @click="submitForm('ruleForm')"
                @keyup.enter.native="submitForm('ruleForm')"
                class="_reg_now"
              >{{$t('dialog.login')}}</el-button>
            </el-form-item>
            <div class="_gosingup_btn" @click="handleGosignup">
              {{ $t("newHome.signup")}} 
            </div>
          </el-form>
        </div>
        <!-- <p class="forgetPosword" @click="handleClickForgetPossword">{{$t('forget.title')}}?</p> -->
      </div>
    </dialogTem>
    <forget-password ref="f_p"></forget-password>
  </div>
</template>

<script>
import forgetPassword from '../forgetPassword'
import dialogTem from '../dialogTem.vue'
import { mapState, mapActions, mapMutations } from "vuex";
import { check, common } from "@/common/index";
export default {
  components:{ dialogTem, forgetPassword },
  data() {
    let checkusername = (rule, value, callback) => {
      let reg = /^[A-Za-z0-9]{6,12}$/;
      if (value === "") {
        let str = this.$t('login.userRules1');
        callback(new Error(str));
      } else {
        callback();
      }
      // else if (!reg.test(value)) {
      //   let str = this.$t('login.userRules2');
      //   callback(new Error(str));
      // } 
     
    };
    let checkpassword = (rule, value, callback) => {
      // let reg = /^[A-Za-z0-9]{6,12}$/;
      if (value === "") {
        let str = this.$t('login.passwordRules');
        callback(new Error(str));
      } else {
        callback();
      }
    };
    let checkverificationCode = (rule, value, callback) => {
      if (value === "") {
        let str = this.$t('login.verificationRules');
        callback(new Error(str));
      } else {
        callback();
      }
    };
    return {
      flag:true,
      user: {
        username: "",
        password: "",
        repeatPassword: "",
        phoneNumber: "",
        agentCode: "",
        domain: "",
        securityCodeSrc: "",
        timestamp: "",
        verificationCode: "",
      },
      styleColor: false,
      styleColor02: false,
      styleColor03:false,
      checked: false,
      config: {
        width: 160, // 设置宽度
        height: 160, // 设置高度
        text: "",
      },
      isShow: "password",
      isReady: false,
      rules: {
        username: [
          { validator: checkusername, trigger: "blur", required: true },
        ],
        password: [
          { validator: checkpassword, trigger: "blur", required: true },
        ],
        verificationCode: [
          {
            validator: checkverificationCode,
            trigger: "blur",
            required: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      showloginfloat2: (state) => state.showloginfloat2,
      appJump: (state) => state.linkList.appJump,
    }),
  },
  methods: {
    ...mapMutations(["setshowloginfloat", "setshowloginfloat2"]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "Login","getFirstInfo"]),
    handleGosignup(){
      this.setshowloginfloat2(false)
      this.setshowloginfloat(true)
    },
    handleClickForgetPossword(){
      this.$refs.f_p.forgetPassword =!this.$refs.f_p.forgetPassword
      this.setshowloginfloat2(false)
    },
    handleFocus(ele,val){
      if(!ele){
        if(val === 'username'){
          this.styleColor = !this.styleColor
        }
        if(val === 'password'){
          this.styleColor02 = !this.styleColor02
        }
        if(val === 'verificationCode'){
          this.styleColor03 = !this.styleColor03
        }
      }
    },
    handleBlur(ele,val){
      if(!ele){
        if(val === 'username'){
          this.styleColor = !this.styleColor
        }
        if(val === 'password'){
          this.styleColor02 = !this.styleColor02
        }
        if(val === 'verificationCode'){
          this.styleColor03 = !this.styleColor03
        }
      }
    },
    switchPass() {
      this.isShow = this.isShow == "password" ? "text" : "password";
    },
    // 提示语
    _notifyFun(title,type,message,Ready){
      this.isReady = Ready;
      this.getVifyCode();
      this.$notify({ duration: 8000,title:this.$t(title), message:message, type:type,});
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            username: this.user.username,
            password: this.user.password,
            timestamp: this.user.timestamp,
            vrifyCode: this.user.verificationCode,
          };
          this.isReady = true;
          this.$api.post(this.$urls.USER.LOGIN, params,(resp) => {
            this.isReady = false;
            if (resp.data.code === undefined) {
              if (resp.data.data.code === 200) {
                common.logedUserInfo();
                this.setshowloginfloat2(false);
                this.$refs[formName].resetFields();
                let data = resp.data.data;
                if (data["UUID"]) {
                  this.checkLogin();
                  this.getFirstInfo();
                  this.styleColor = false
                  this.styleColor02 = false
                  this.styleColor03 = false
                }
                if (this.$route.query.redirect) {
                  this.$router.push({ path: this.$route.query.redirect });
                }else{
                  this.$router.push({path:'/'})
                }
                this.isReady = false;
              } else {
                this._notifyFun('notify.warning','warning',resp.data.data.msg,this.isReady)
              }
            } else {
              let msg = resp.data.msg ? resp.data.msg : resp.data.message;
              this._notifyFun('notify.warning','warning',msg,false)
            }
          },(err) => {
            this._notifyFun('notify.warning','warning',err,false)
          });
        }
      });
    },
    // 获取验证码
    getVifyCode() {
      this.vrifyCode = "";
      let randomStr = common.randomRange(16);
      let timer = Math.floor(Date.now() / 1000);
      this.user.securityCodeSrc =this.$urls.USER.REGISTERCODE + `?timestamp=${timer}` + randomStr;
      this.user.timestamp = timer + randomStr;
    },
    openQrCode() {
      this.$nextTick(() => {
        if (this.appJump && this.showloginfloat2) {
          this.qrcode();
        }
      });
    },
    closeQrCode() {
      // $('#qrcode-vue1').html("")
      document.getElementById("qrcode-vue1").innerHTML = "";
    },
    qrcode() {
      this.$set(this.config, "text", this.appJump);
      let qrcode = new QRCode("qrcode-vue1", this.config);
    },
  },
  mounted() {
    this.getVifyCode();
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
.RememberMe{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.registerFloat {
  .login-body {
    padding:0px 22px 51px;
    .box-left .el-form {
      .login {
        color: #fff;
        text-align: center;
        cursor: pointer;
        padding-bottom: 15px;
      }
      .el-form-item {
        margin-bottom:10px!important;
        width: 100%;
        display: inline-block;
        &.btn-group{ margin-bottom:0!important;}
      }
    }
    ._gosingup_btn{
      width:100%;
      // background-color: #d2ffdb;
      // box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
      margin-top:10px;
      line-height: 44px;
      cursor: pointer;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 600;
      color: #bebf01;
      text-align: center;
      border:2px solid #bebf01;
    }
    // .forgetPosword{
    //   cursor: pointer;
    //   font-family: ArialMT;
    //   font-size: 20px;
    //   font-weight: normal;
    //   font-stretch: normal;
    //   line-height: 50px;
    //   letter-spacing: 0px;
    //   color: #323232;
    //   text-align: center;
    // }
  }
}
  .fresh_ico{
    display: inline-block; width: 19px; height: 20px; background: url(../img/fresh_ico.png) no-repeat; vertical-align: middle; cursor: pointer;
  }
  .forgetPosword2{
      cursor: pointer;
      font-family: ArialMT;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 50px;
      letter-spacing: 0px;
      color: #999;
      text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/register/login.vue